/**
 * ScoreSystem - Detects when the ball enters a goal zone and updates GameState.
 * Listens to ball position each frame and triggers goal events.
 */

import * as BABYLON from "babylonjs";
import { GameState, State } from "./GameState";
import { BALL_RADIUS } from "../entities/Ball";

const GOAL_HEIGHT = 3.5;

export class ScoreSystem {
  private _cooldown = 0; // prevent double-scoring
  private _goalCount = 0; // track total goals for debugging

  constructor(
    private _gameState: GameState,
    private _ball: BABYLON.Mesh,
    private _playerGoalZ: number, // z-position of the goal the player attacks
    private _opponentGoalZ: number, // z-position of the goal the opponent attacks
    private _goalHalfWidth: number,
    private _onGoal: (side: "player" | "opponent") => void
  ) {}

  update(dt: number): void {
    if (this._gameState.state !== State.Playing) return;

    if (this._cooldown > 0) {
      this._cooldown -= dt;
      return;
    }

    const pos = this._ball.position;
    const inGoalX = Math.abs(pos.x) < this._goalHalfWidth;
    const underCrossbar = pos.y < GOAL_HEIGHT;

    // Ball crossed FULLY into the goal the player is attacking → player scores
    // (center + radius past the line)
    if (inGoalX && underCrossbar && pos.z >= this._playerGoalZ + BALL_RADIUS) {
      this._goalCount++;
      console.log(`ScoreSystem: Player goal #${this._goalCount} detected at ball pos z=${pos.z.toFixed(2)}`);
      this._gameState.addGoal("player");
      this._cooldown = 2;
      this._onGoal("player");
    }
    // Ball crossed FULLY into the goal the opponent attacks → opponent scores
    else if (inGoalX && underCrossbar && pos.z <= this._opponentGoalZ - BALL_RADIUS) {
      this._goalCount++;
      console.log(`ScoreSystem: Opponent goal #${this._goalCount} detected at ball pos z=${pos.z.toFixed(2)}`);
      this._gameState.addGoal("opponent");
      this._cooldown = 2;
      this._onGoal("opponent");
    }
  }
}
